import axios from "axios";
import {  GetNotificationPaginUrl } from "../urls";
import {   getToken, getTokenHeaderFile } from "../../../../v3/Common/Token";

export const GetNotificationsPaginData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(GetNotificationPaginUrl(), {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
